import { Trans } from "@lingui/react/macro";
import { PlainButton } from "@medoma/components/Button/Button";

export const ShowNonMatchingShiftsButton = ({
  numberOfNonMatchingShifts,
  onClick,
}: {
  numberOfNonMatchingShifts: number;
  onClick: () => void;
}) => (
  <PlainButton size="small" onClick={onClick}>
    <Trans>Visa övriga arbetspass ({numberOfNonMatchingShifts})</Trans>
  </PlainButton>
);
